import { randNumber } from '@ngneat/falso';
import { LabJobStatus } from '@principle-theorem/principle-core/interfaces';
import { ILabJobDimension } from '@principle-theorem/reporting/interfaces';
import {
  MockGenerator,
  toSerialisedTimestamp,
  toTimestamp,
} from '@principle-theorem/shared';
import {
  AvroSerialisedRawInlineNodesMock,
  AvroSerialisedVersionedSchemaMock,
  BigQueryFirestoreModelMock,
  BigQueryInteractionMock,
  BigQueryNamedDocumentMock,
  MockBigQueryStatusHistory,
  SerialisedDocumentReferenceMock,
} from './common.mock';

export class LabJobDimensionMock
  extends BigQueryFirestoreModelMock<ILabJobDimension>
  implements ILabJobDimension
{
  timestamp = toSerialisedTimestamp(toTimestamp());
  status = LabJobStatus.Sent;
  type = {
    ...MockGenerator.generate(BigQueryFirestoreModelMock),
    name: 'Crown',
    cost: randNumber({ min: 50, max: 500 }),
  };
  lab = new BigQueryNamedDocumentMock();
  practitioner = MockGenerator.generate(BigQueryNamedDocumentMock);
  statusHistory = [
    MockBigQueryStatusHistory(LabJobStatus.Sending),
    MockBigQueryStatusHistory(LabJobStatus.Sent),
  ];
  patient = MockGenerator.generate(BigQueryNamedDocumentMock);
  appointment = {
    treatmentPlanName: 'Mock Treatment Plan',
    ref: MockGenerator.generate(SerialisedDocumentReferenceMock),
  };
  cost = randNumber({ min: 50, max: 500 });
  description = MockGenerator.generate(AvroSerialisedVersionedSchemaMock);
  title = MockGenerator.generate(AvroSerialisedRawInlineNodesMock);
  dueDate = toSerialisedTimestamp(toTimestamp());
  sentAt = toSerialisedTimestamp(toTimestamp());
  receivedAt = toSerialisedTimestamp(toTimestamp());
  issuedAt = toSerialisedTimestamp(toTimestamp());
  completedDate = toSerialisedTimestamp(toTimestamp());
  interactions = [
    MockGenerator.generate(BigQueryInteractionMock),
    MockGenerator.generate(BigQueryInteractionMock),
    MockGenerator.generate(BigQueryInteractionMock),
  ];
}
